<template>
    <div class="container-fluid">
        <Breadcrumb title="Uuid Decoder" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card text-white bg-danger" v-if="showFailureMessage">
                    <div class="card-header">
                        <h4 class="m-b-0 text-white">Validation Errors</h4></div>
                    <div class="card-body">
                        <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                        <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                            {{key}}: {{error}}
                        </p>
                    </div>
                </div>
                <div class="col-xl-6 float-left pl-0 pr-xl-3 pr-0">
                    <div class="card">
                        <div class="card-body">
                            <form @submit.prevent="decode" class="form-horizontal form-material">
                                <br/>
                                <div class="form-group">
                                    <label for="uuid" class="mb-1">Email ID:</label>
                                    <input id="uuid" v-model="encoded.emailId" type="text" class="form-control">
                                    <div class="text-danger" v-if="$v.encoded.emailId.$error">Required.</div>
                                </div>
                                <div class="form-group text-center">
                                    <br/>
                                    <div class="col-xs-12 p-b-5">
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                                v-show="!submitting">
                                            Decode
                                        </button>
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                                disabled
                                                v-show="submitting">
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                  aria-hidden="true"></span>
                                            . . .
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-xl-6 float-left pl-0 pr-xl-3 pr-0">
                    <div class="card">
                        <div class="card-body">
                            <form @submit.prevent="encode" class="form-horizontal form-material">
                                <br/>
                                <div class="form-group">
                                    <label for="campaignId" class="mb-1">Email:</label>
                                    <input id="campaignId" v-model="decoded.email" type="text"
                                           class="form-control">
                                    <div class="text-danger" v-if="$v.decoded.email.$error">Invalid Email</div>
                                </div>
                                <div class="form-group text-center">
                                    <br/>
                                    <div class="col-xs-12 p-b-5">
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                                v-show="!submitting">
                                            Encode
                                        </button>
                                        <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light"
                                                disabled
                                                v-show="submitting">
                                            <span class="spinner-border spinner-border-sm" role="status"
                                                  aria-hidden="true"></span>
                                            . . .
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ToolsService from "../services/ToolsService";
    import Swal from 'sweetalert2'
    import Breadcrumb from '../components/Breadcrumb';
    import {email, required} from 'vuelidate/lib/validators';

    export default {
        name: 'UuidDecoder',
        components: {
            Breadcrumb
        },
        data() {
            return {
                encoded: {
                    emailId: ''
                },
                decoded: {
                    email: ''
                },
                showFailureMessage: false,
                submitting: false,
                errors: []
            }
        },
        mounted() {
        },
        computed: {},
        validations: {
            encoded: {
                emailId: {required}
            },
            decoded: {
                email: {email, required}
            }
        },
        methods: {
            decode: function () {
                this.showFailureMessage = false;
                this.$v.encoded.$touch();
                if (this.$v.encoded.$invalid) return;
                this.submitting = true;
                ToolsService.emailIdDecode(JSON.stringify(this.encoded)).then(response => {
                    if (response.status === 200) {
                        this.decoded.email = response.data.decoded;
                    } else {
                        this.errors = response.data.error;
                        this.showFailureMessage = true;
                    }
                    this.submitting = false;
                }).catch(error => {
                    this.submitting = false;
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    })
                });
            },
            encode: function () {
                this.showFailureMessage = false;
                this.$v.decoded.$touch();
                if (this.$v.decoded.$invalid) return;
                this.submitting = true;
                ToolsService.emailIdEncode(JSON.stringify(this.decoded)).then(response => {
                    if (response.status === 200) {
                        this.encoded.emailId = response.data.encoded;
                    } else {
                        this.errors = response.data.error;
                        this.showFailureMessage = true;
                    }
                    this.submitting = false;
                }).catch(error => {
                    this.submitting = false;
                    Swal({
                        type: 'error',
                        title: 'Oops...',
                        text: `${error}`,
                    })
                });
            },
        }
    }
</script>

<style scoped>

</style>